export default "/assets/images/column-image7.fc032027f581b798.webp";